import script from "./company-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-card.vue?vue&type=script&setup=true&lang=ts"

import "./company-card.vue?vue&type=style&index=0&id=664e4378&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664e4378"]])

export default __exports__